import type { DataContainer } from "@otto-ec/tracking-bct";
import type { QBus } from "@otto-ec/global-resources/event-q-bus";
import type { DresonRuleResolvedEvent } from "./DresonRuleResolvedEvent";
import type { TeaserClient } from "./TeaserClient";
import { createLogger } from "utils/logging";
import { addLoadedTracking, addMiniActionsToVisibilityChanges } from "../utils";
import type { Debug } from "@otto-ec/global-resources/debug";
import { unlockInit as unlockTrackingInit } from "@otto-ec/global-resources/tracking";
import { insertHtmlFragment } from "@otto-ec/global-resources/dom";

const log = createLogger("cinema", "teaser");
const PARENT_ID = "FT9-benefit-cinema-bottom";

export class Teaser {
	constructor(
		private readonly teaserClient: TeaserClient,
		private readonly eventQBus: QBus,
	) {}

	init() {
		const container = document.getElementById("benefit_teaser");
		if (!container) {
			return;
		}

		const initialized = container.dataset.initialized;
		if (initialized && initialized === "true") {
			return;
		}
		container.setAttribute("data-initialized", "true");

		const psr = container.dataset.psr;
		if (psr) {
			this.retrieveBenefit(psr, container);
		}

		/*                                                                             */
		this.eventQBus.on("ftfind.dresonRule.resolved", (event?: DresonRuleResolvedEvent) => {
			/*                                              */
			/*                                                                                         */
			/*                                                                                                     */
			setTimeout(() => {
				const newContainer = document.getElementById("benefit_teaser");
				const newPsr = event?.rule;
				if (!newPsr || !newContainer) {
					return;
				}
				newContainer.replaceChildren();
				newContainer.setAttribute("data-initialized-event", "true");

				this.retrieveBenefit(newPsr, newContainer);
			}, 2_000);
		});

		/*                                                                    */
		if (document.querySelector('[data-testid="ft9_teaser_test"]')) {
			this.initTracking(container);
		}
	}

	retrieveBenefit(psr: string, container: HTMLElement) {
		const url = "/benefit-cinema/teaser/productlist";
		const params = new URLSearchParams();
		params.append("psr", psr);

		const topCinema = document.querySelector(`[data-module*="ft9-benefit-cinema-productlist-root"] > oc-cinema-v1`);
		if (topCinema) {
			const slidesInTopCinema = Array.from(topCinema.querySelectorAll("oc-paper-card-v1"));
			for (const benefitSlide of slidesInTopCinema) {
				if (benefitSlide instanceof HTMLElement) {
					const benefitId = benefitSlide.dataset.benefitId;
					if (benefitId) {
						params.append("benefitIdsInCinema", benefitId);
					}
				}
			}
		}

		log.info("url to request benefit teaser %s", url);

		this.teaserClient
			.get(`${url}?${params.toString()}`)
			.then((response) => {
				log.debug("successfully retrieved teaser benefit %s", response);
				insertHtmlFragment(response, container, { activateInlineScripts: true, replace: true });
				container.setAttribute("data-loaded", "true");

				this.initTracking(container);
			})
			.catch((reason) => {
				log.warn("Error when requesting teaser benefit %s", psr, reason);
			});
	}

	initTracking(container: HTMLElement) {
		const cinema = container.querySelector<HTMLOcCinemaV1Element>("oc-cinema-v1");
		if (!cinema) {
			return log.info("no cinema found in teaser");
		}

		const additionalLabel: DataContainer = { benefit_Slot: ["footer"] };

		/*                                                                                      */
		cinema.addEventListener("tr-submit-tracking", ({ detail }) => {
			switch (true) {
				case detail.eventName === "tr-become-visible" && detail.method === "submitMiniAction":
					addMiniActionsToVisibilityChanges(detail, cinema, "scroll", PARENT_ID);
					break;
				case detail.eventName === "tr-page-impression" && detail.method === "submitMerge":
					/*                                                                                */
					addLoadedTracking(detail, cinema, 1, log as unknown as Debug<string>, PARENT_ID, additionalLabel);
					break;
				default:
					break;
			}
		});

		unlockTrackingInit(cinema);
	}
}
